import { ReactNode } from 'react';

import { FormWithBackgroundVariants } from '../FormWithBackgroundVariants.enum';
import FormDescription from './FormDescription';
import FormTitle from './FormTitle';

import clsx from 'clsx';

type FormWrapperProps = {
  title?: string;
  description?: string;
  variant?: FormWithBackgroundVariants;
  children: ReactNode;
  extended: boolean;
  onExtended: () => void;
};

export default function FormWrapper({
  title,
  description,
  variant,
  children,
  extended,
  onExtended,
}: FormWrapperProps) {
  const isVertical = variant === FormWithBackgroundVariants.VerticalForm;

  return (
    <div className="flex justify-center">
      {isVertical && (
        <div className="max-lg:hidden h-5 mb-5 w-[323px] xl:w-[380px]"></div>
      )}
      <div
        className={clsx(
          'p-5 bg-almond-99 rounded mb-5 max-md:flex-grow',
          !extended && 'max-md:max-h-[350px] max-md:overflow-hidden',
          isVertical &&
            'lg:absolute lg:z-[2] lg:top-[-160px] lg:right-[-20px] shadow-md',
          !isVertical && 'max-w-[520px] relative lg:w-[520px]'
        )}
        onClick={onExtended}
      >
        {title && <FormTitle title={title} />}
        {description && <FormDescription description={description} />}

        {children}

        {!extended && (
          <div
            className={clsx(
              'absolute top-0 left-0 w-full h-full md:hidden',
              'bg-gradient-to-t from-white from-40% via-transparent'
            )}
          ></div>
        )}
      </div>
    </div>
  );
}
